import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { VPMNNetwork } from 'src/app/segment/model/report/VPMNNetwork';

import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';

@Component({
  selector: 'app-add-network-addition',
  templateUrl: './add-network-addition.component.html',
  styleUrls: ['./add-network-addition.component.scss']
})
export class AddNetworkAdditionComponent implements OnInit {

  addNetworkAdditionForm: FormGroup;
    loadPage: boolean;
    vpmnNetworkList: any[] = [];

   
    fileToUpload: any;
    selectedVPMNOrgId: string = "";
    submitted = false;
    vpmnNetworkyList:any;
    hpmnCountry:any;
  // vpmnNetworkList: any;
  selectedRoamOrgId: any;
   
    
  
    constructor(private dialogRef: MatDialogRef<AddNetworkAdditionComponent>,
       private formBuilder: FormBuilder,
      private router: Router, private dialog: MatDialog,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private spinnerService: Ng4LoadingSpinnerService,
      private endpointsService: EndpointsService,
      
      private backendApiService: BackendApiService) {}
  
    ngOnInit(): void {
      this.createBlacklistForm();
      // this.hpmnCountry = sessionStorage.getItem('homeCountry');
      this.hpmnCountry = 'South Africa'
      this.loadPage = true;
      this.getVPMNCountryDetails();
     
    }
  
    createBlacklistForm() {
      this.addNetworkAdditionForm = this.formBuilder.group({
        homecc: ['', [Validators.minLength(1), Validators.maxLength(12), Validators.required, Validators.pattern("^[0-9]*$")]],
        visitingcc: ['', [Validators.minLength(1), Validators.maxLength(12), Validators.required, Validators.pattern("^[0-9]*$")]],
        hpmnCountry:[''],
        VPMNCountry:['',Validators.required],
        VPMNNetwork:[''],
        islive:[''],
       
      });
    }
    get f() {
      return this.addNetworkAdditionForm.controls;
    }
    async getVPMNCountryDetails() {
      this.spinnerService.show();
      const apiUrl = this.endpointsService.URL_COUNTRY_FOR_NETWORK_ADDITION 
      this.backendApiService.callToApi(apiUrl).subscribe(response => {
        this.vpmnNetworkyList = response.countries   
        console.log("VPMN Country List:", this.vpmnNetworkyList);
        this.spinnerService.hide();
      });
    }

  onVPMNNetworkChange(selectedCountry: string): void {
  if (!selectedCountry) {
    this.vpmnNetworkList = [];
    this.addNetworkAdditionForm.get('VPMNNetwork').setValue('');
    return;
  }

  const orgId = '6108';
  const encodedCountry = encodeURIComponent(selectedCountry);
  const apiUrl = `${this.endpointsService.URL_GET_NETWORK_FOR_SELECTED_COUNTRY}&orgId=${orgId}&visitingCountry=${encodedCountry}`;

  this.spinnerService.show();
  this.backendApiService.callToApi(apiUrl).subscribe(
    (response: any[]) => {
      this.spinnerService.hide();
      this.vpmnNetworkList = response || [];

      if (response.length === 1) {
        const network = response[0];
        this.addNetworkAdditionForm.patchValue({
          VPMNNetwork: network.vistingNetwork,
          visitingcc: network.cc,
          homecc: '27'
        });
      } else {
        // Multiple networks, clear fields and let user select
        this.addNetworkAdditionForm.patchValue({
          VPMNNetwork: '',
          visitingcc: '',
          homecc: '27'
        });
      }
    },
    error => {
      console.error('Error fetching visiting networks', error);
      this.vpmnNetworkList = [];
      this.spinnerService.hide();
    }
  );
}


onNetworkSelection(selectedNetwork: string): void {
  const selected = this.vpmnNetworkList.find(item => item.vistingNetwork === selectedNetwork);
  if (selected) {
    this.addNetworkAdditionForm.patchValue({
      visitingcc: selected.cc || '',
      homecc: '27'
    });
  }
}



// onNetworkSelected(selectedNetwork: string): void {
//   const networkObj = this.vpmnNetworkList.find(item => item.vistingNetwork === selectedNetwork);
//   if (networkObj) {
//     this.selectedRoamOrgId = networkObj.cc;
//     console.log('Selected Roam Org ID:', this.selectedRoamOrgId);
//   } else {
//     this.selectedRoamOrgId = '';
//   }
// }
    // onVPMNNetworkChange(selectedCountry: string) {
    //   const selectedItem = this.vpmnNetworkyList.find(item => item.visitingNetwork === selectedCountry);
    //   this.selectedVPMNOrgId = selectedItem ? selectedItem.vistingOrgId : "";
    //   console.log("Selected Org ID:", this.selectedVPMNOrgId);
    // }
    onClose() {
      this.dialogRef.close();
    }
    numberOnly(event:any): boolean {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        return false;
      }
      return true;
    }
  
    onInsert() {
      this.submitted = true;
      if (this.addNetworkAdditionForm.invalid) {
          return;
        }
      this.spinnerService.show();
      const apiUrl = this.endpointsService.URL_ADD_NETWORK_ADDITION +
          '&orgId=' + sessionStorage.getItem('userOrgId').split(" ").join("")+'&vistingOrgId=' + this.selectedVPMNOrgId +
          '&vistingCC='+ this.addNetworkAdditionForm.get('visitingcc').value +
          '&homeCC='+this.addNetworkAdditionForm.get('homecc').value +
          '&is_live='+this.addNetworkAdditionForm.get('islive').value
      
        this.backendApiService.callToApi(apiUrl).subscribe(res=>{
          console.log("response",res);
         if(res.status=='Created'){
          alert(res.message);
          this.dialogRef.close(res.status);
         }else{
          alert(res.message);
          return;
         }
        })
    }
   storeAnalytics() {
      
      const apiUrl1 = this.endpointsService.CENTRY_LOG +
        'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Network Addition' + '&module=Network Addition' + '&operation=Add' + '&opname=Add';
      this.backendApiService.callToApi(apiUrl1).subscribe(response => {
       console.log(response);
      });
  
  
    }
  
}
